import { rootApi } from "../../api/rootApi";

export const cacheManagementApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenantCacheStatus: builder.mutation({
      query: (p) => ({ method: "GET", url: "/tenant/cache/status", headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    getUserProfileCacheStatus: builder.mutation({
      query: (p) => ({ method: "GET", url: `/tenant/cache/user-profile?mobile=${p.mobile}`, headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    clearUserProfileCache: builder.mutation({
      query: (p) => ({ method: "DELETE", url: `/tenant/cache/user-profile?mobile=${p.mobile}`, headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    getProductCacheStatus: builder.mutation({
      query: (p) => ({ method: "GET", url: `/tenant/cache/product?code=${p.code}`, headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    clearProductCache: builder.mutation({
      query: (p) => ({ method: "DELETE", url: `/tenant/cache/product?code=${p.code}`, headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    clearTenantRulesCache: builder.mutation({
      query: (p) => ({ method: "DELETE", url: "/tenant/cache/rules", headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    clearSchemesCache: builder.mutation({
      query: (p) => ({ method: "DELETE", url: "/tenant/cache/schemes", headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    clearCompanyCache: builder.mutation({
      query: (p) => ({ method: "DELETE", url: "/tenant/cache/company", headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    clearAllUserProfileCaches: builder.mutation({
      query: (p) => ({ method: "DELETE", url: "/tenant/cache/users-all", headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    clearAllProductCaches: builder.mutation({
      query: (p) => ({ method: "DELETE", url: "/tenant/cache/products-all", headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
    clearAllTenantCaches: builder.mutation({
      query: (p) => ({ method: "DELETE", url: "/tenant/cache/all", headers: { Authorization: "Bearer " + p.token, slug: p.tenant_id } }),
    }),
  }),
});

export const {
  useGetTenantCacheStatusMutation,
  useGetUserProfileCacheStatusMutation,
  useClearUserProfileCacheMutation,
  useGetProductCacheStatusMutation,
  useClearProductCacheMutation,
  useClearTenantRulesCacheMutation,
  useClearSchemesCacheMutation,
  useClearCompanyCacheMutation,
  useClearAllUserProfileCachesMutation,
  useClearAllProductCachesMutation,
  useClearAllTenantCachesMutation,
} = cacheManagementApi;
